<button mat-flat-button class="menu-btn {{ className }}" [disabled]="disabled" [routerLink]="routerLinkName || null" (click)="buttonClick()" [style.opacity]="disabled?0.2:1">
  {{ buttonText }}
</button>
